import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchSettings, resolveUrl } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const s = await fetchSettings();
      setSettings(s);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const logo = resolveUrl(settings.logo_url);

  // Keep the browser-tab favicon in sync with the brand logo from Settings,
  // so the tab icon is always the exact same image as the header brand logo.
  useEffect(() => {
    const href = logo || `${process.env.PUBLIC_URL || ""}/zed-logo.png`;
    document
      .querySelectorAll('link[rel~="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]')
      .forEach((el) => el.remove());
    [["icon", href], ["shortcut icon", href], ["apple-touch-icon", href]].forEach(([rel, h]) => {
      const link = document.createElement("link");
      link.rel = rel;
      link.href = h;
      document.head.appendChild(link);
    });
  }, [logo]);

  return (
    <SettingsContext.Provider value={{ settings, loading, reload, logo }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
